import { render, staticRenderFns } from "./policy-details.vue?vue&type=template&id=d2ade6cc&scoped=true&"
import script from "./policy-details.vue?vue&type=script&lang=js&"
export * from "./policy-details.vue?vue&type=script&lang=js&"
import style0 from "./policy-details.vue?vue&type=style&index=0&id=d2ade6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ade6cc",
  null
  
)

export default component.exports